// src/enduser/pubutil.js
// 公開画面で共通に使う、小さな整形関数

const pad2 = (n) => String(n).padStart(2, "0");
const DOW_EN = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

// "YYYY-MM-DD" をローカル日付として扱う（new Date(iso) だとUTC扱いで日付がずれる恐れがある）
export const parseDate = (iso) => {
  const [y, m, d] = String(iso || "").split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

// "2026-09-26" → "2026.09.26 SAT"（日付が不正なら空文字）
export const formatEyebrow = (iso) => {
  const d = parseDate(iso);
  if (!d) return "";
  return `${d.getFullYear()}.${pad2(d.getMonth() + 1)}.${pad2(d.getDate())} ${DOW_EN[d.getDay()]}`;
};
